import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { NewsBody, NewsDetails, NewsListItem } from "types/api/news";

function useNewsApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllNews = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<NewsListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<NewsListItem>>({
            url: "/news",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const getOneNews = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<NewsDetails> => {
        return get<PathParamsWithId, undefined, NewsDetails>({
            url: "/news/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createNews = React.useCallback((body: NewsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, NewsBody, ResponseWithId>({
            url: "/news",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateNews = React.useCallback((pathParams: PathParamsWithId, body: NewsBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, NewsBody, null>({
            url: "/news/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteNews = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/news/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllNews,
        getOneNews,
        createNews,
        updateNews,
        deleteNews
    };
}

export default useNewsApi;